import React, { forwardRef } from "react";

const WB = forwardRef(({ ...props }, ref) => (
  <svg
    width="112"
    height="14"
    viewBox="0 0 112 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}>
    <path
      d="M3.40976 13.2798L0 0.67749H2.25781L4.88425 10.3538L7.695 0.67749H9.79154L12.6023 10.3999L15.2287 0.67749H17.4635L14.0537 13.2798H11.4503L8.70871 3.8799L5.99012 13.2798H3.40976Z"
      fill="#BE11A5"
    />
    <path d="M19.0303 0.67749H21.1729V13.2798H19.0303V0.67749Z" fill="#BE11A5" />
    <path d="M25.7115 11.2983H30.8953V13.2797H23.615V0.700439H25.7115V11.2983Z" fill="#BE11A5" />
    <path
      d="M37.4844 0.700478C39.1202 0.6544 40.7098 1.32253 41.8388 2.52055C44.1657 5.0318 44.1657 8.94841 41.8388 11.4597C40.7098 12.6577 39.1202 13.3258 37.4844 13.2797H32.4619V0.700478H37.4844ZM37.4844 11.2984C38.6824 11.2984 39.6731 10.8837 40.4103 10.0773C41.1937 9.24792 41.6084 8.11901 41.5623 6.9901C41.6084 5.83816 41.1937 4.73229 40.4103 3.90289C39.6501 3.09653 38.5903 2.63575 37.4844 2.68183H34.5585V11.2984H37.4844Z"
      fill="#BE11A5"
    />
    <path
      d="M54.8328 9.68566C54.8558 10.6533 54.4411 11.5979 53.7269 12.243C52.9897 12.9341 52.022 13.3028 51.0083 13.2797H45.5481V0.700482H50.6167C51.5843 0.677443 52.5289 1.04607 53.2661 1.69116C53.9803 2.31321 54.372 3.23476 54.349 4.17936C54.395 5.19307 53.8882 6.16071 53.0588 6.73668C54.1646 7.28961 54.8558 8.44156 54.8328 9.68566ZM47.6446 2.63575V5.95336H50.6167C51.5382 5.95336 52.2755 5.21611 52.2755 4.29455C52.2755 3.373 51.5382 2.63575 50.6167 2.63575H47.6446ZM51.0083 11.3214C51.9759 11.2753 52.7362 10.469 52.6902 9.50135C52.6671 8.57979 51.9068 7.84255 51.0083 7.81951H47.6446V11.3445L51.0083 11.3214Z"
      fill="#BE11A5"
    />
    <path
      d="M58.9337 11.2983H64.5782V13.2797H56.8372V0.700439H64.4861V2.68179H58.9337V5.95331H64.0483V7.91162H58.9337V11.2983Z"
      fill="#BE11A5"
    />
    <path
      d="M73.7249 13.2797L71.0063 8.69492H68.5411V13.2797H66.4446V0.677379H71.5592C72.6421 0.654341 73.7018 1.09208 74.4621 1.8754C75.2454 2.61265 75.6832 3.6494 75.6601 4.73223C75.6371 6.34495 74.6464 7.7964 73.1259 8.37237L76.0288 13.2797H73.7249ZM68.5411 2.63569V6.85181H71.5362C72.6881 6.80573 73.5866 5.81506 73.5406 4.64007C73.4945 3.55724 72.619 2.68176 71.5362 2.63569H68.5411Z"
      fill="#BE11A5"
    />
    <path
      d="M84.8984 13.2797L82.2028 8.69492H79.7377V13.2797H77.6411V0.677379H82.7558C83.8386 0.654341 84.8984 1.09208 85.6587 1.8754C86.442 2.61265 86.8797 3.6494 86.8567 4.73223C86.8336 6.34495 85.843 7.7964 84.3224 8.37237L87.2253 13.2797H84.8984ZM79.7377 2.63569V6.85181H82.7327C83.9077 6.78269 84.7832 5.79202 84.7141 4.61703C84.6449 3.55724 83.7925 2.68176 82.7327 2.63569H79.7377Z"
      fill="#BE11A5"
    />
    <path d="M88.7458 0.67749H90.8424V13.2798H88.7458V0.67749Z" fill="#BE11A5" />
    <path
      d="M95.4042 11.2983H101.049V13.2797H93.3076V0.700439H100.957V2.68179H95.4042V5.95331H100.519V7.91162H95.4042V11.2983Z"
      fill="#BE11A5"
    />
    <path
      d="M102.523 10.4229L104.344 9.38617C104.85 10.8146 105.91 11.5057 107.5 11.5057C109.09 11.5057 109.873 10.8376 109.873 9.84694C109.896 9.38617 109.642 8.92539 109.228 8.695C108.813 8.41853 108.053 8.11902 106.97 7.79648C105.749 7.42786 105.15 7.19747 104.297 6.64453C103.445 6.0916 103.053 5.23916 103.053 4.11025C103.007 3.09654 103.468 2.10587 104.251 1.46078C105.058 0.79265 106.094 0.447066 107.154 0.470104C109.066 0.400988 110.817 1.50686 111.601 3.23477L109.85 4.22545C109.32 3.0735 108.421 2.47449 107.177 2.47449C105.933 2.47449 105.173 3.0735 105.173 4.04114C105.173 5.00877 105.795 5.40043 107.753 5.99944C108.237 6.16072 108.583 6.27591 108.813 6.36807C109.043 6.46022 109.366 6.57542 109.758 6.73669C110.08 6.85189 110.403 7.0362 110.679 7.24355C111.347 7.77344 112.085 8.62588 111.992 9.8239C112.039 10.8837 111.578 11.8744 110.748 12.5425C109.919 13.2106 108.836 13.5332 107.477 13.5332C104.966 13.5101 103.169 12.3351 102.523 10.4229Z"
      fill="#BE11A5"
    />
  </svg>
));

export default WB;
